// extracted by mini-css-extract-plugin
export var auto = "_redotech-redo-web-lib-spinner-auto";
export var spinner = "_redotech-redo-web-lib-spinner-spinner";